import axios from "axios"
import {from, of} from "rxjs"
import {mergeMap} from "rxjs/operators"
import {uploadServiceEndpoint, buildApiUrl} from "@/AppConfig"

const AppApi = {
  loadApiKey: () => {
    return from(
      axios.get(
        buildApiUrl("/api/key"),
        {headers: {"Content-Type": "application/json"}}
      )
    ).pipe(mergeMap(({data}) => of({data})))
  },

  exchangeToken: ({token, apiKey}) => {
    return from(
      axios.post(
        `${uploadServiceEndpoint}/uploadRequest/validate`,
        {deviceDateTime: new Date()},
        {params: {token}, headers: {apikey: apiKey, "Content-Type": "application/json"}}
      )
    ).pipe(mergeMap(({data}) => of({data})))
  },

  blockedCamera: ({payload, apiKey}) => {
    return from(
      axios.post(
        `${uploadServiceEndpoint}/uploadRequest/blockedCamera`,
        null,
        {params: payload, headers: {apikey: apiKey}}
      )
    ).pipe(mergeMap(({data}) => of({data})))
  },

  captureLocation: ({payload, apiKey}) => {
    const {token, ...rest} = payload
    return from(
      axios.post(
        `${uploadServiceEndpoint}/uploadRequest/location`,
        rest,
        {params: {token}, headers: {apikey: apiKey}}
      )
    ).pipe(mergeMap(({data}) => of({data})))
  },

  logUserJourneyEvent: ({payload, apiKey}) => {
    return from(
      axios.post(
        buildApiUrl("/api/metric/capture"),
        payload,
        {headers: {apikey: apiKey, "Content-Type": "application/json"}}
      )
    ).pipe(mergeMap(({data}) => of({data})))
  },

  getVersion: () => {
    return from(
      axios.get(
        buildApiUrl("/api/version"),
        {headers: {"Content-Type": "application/json"}}
      )
    ).pipe(mergeMap(({data}) => of({data})))
  }
}

export default AppApi
